<script lang="ts">
	import { page } from '$app/stores'
	import DiscordButton from '$lib/components/DiscordButton.svelte'
</script>

<main class="min-h-screen p-10 bg-top">
	<div class="max-w-7xl mx-auto px-4 text-center sm:px-6 sm:py-10 lg:px-8 lg:py-10">
		<p class="text-sm font-semibold text-opacity-50 uppercase tracking-wide" />
		<div class="text-2xl mt-5">
			<div class="flex flex-col space-y-2">
				<p>
					Whoops! Something went wrong and we're looking into it. 
				</p>
				<span class="font-bold p-4">
					{#if $page.error}
						{$page.error.message}
					{/if}
				</span>
				
				<p class="font-normal mt-5">Please try again, or report this to us on Discord.</p>
					<span class="text-red-500">
						Error: {$page.status}

						{#if $page.error?.errorId}{$page.error.errorId.slice(-8)}{/if}
					</span>	
				<p class="mt-5 font-light text-base">
				</p>
			</div>
		</div>
		<div class="flex space-x-2 items-center justify-center mt-10">
			<DiscordButton height="2.5rem" />
			<a href="/" style:height="3.5rem" class="btn-app btn text-xl font-bold w-60"> Try Again </a>
		</div>
	</div>
</main>
